import type { ProfileData } from '@/app/[locale]/leadership/_data/profiles';

import ModalContents from './ModalContents';
import ModalTrigger from './ModalTrigger';

export interface ProfileModalProps {
  readonly profile: ProfileData;
}

const ProfileModal = ({ profile }: ProfileModalProps) => {
  return (
    <ModalTrigger profile={profile}>
      {(overlayState) => <ModalContents {...overlayState} profile={profile} />}
    </ModalTrigger>
  );
};

export default ProfileModal;
